export default "/images/ngm-website.png";